import { ExternalLink, FileText, LifeBuoy, ShieldCheck, Cookie } from "lucide-react";

type TLink = {
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
};

const LEGAL_LINKS: TLink[] = [
  {
    label: "Terms of Service",
    href: "/terms",
    icon: FileText,
    description: "The agreement governing your use of Fundy.",
  },
  {
    label: "Privacy Policy",
    href: "/privacy",
    icon: ShieldCheck,
    description: "How we collect, use, and protect your data.",
  },
  {
    label: "Cookie Policy",
    href: "/cookies-policy",
    icon: Cookie,
    description: "How and why we use cookies.",
  },
];

// Sourced from the build if provided; shown as a dash otherwise (never a fake number).
const APP_VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "—";

export const AboutSettings = () => {
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold">About</h3>
        <p className="text-sm text-muted-foreground">Legal documents, support, and app information.</p>
      </div>

      <section className="space-y-2">
        <div className="text-sm font-semibold">Legal</div>
        <div className="space-y-2">
          {LEGAL_LINKS.map((link) => {
            const Icon = link.icon;
            return (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-between gap-4 rounded-lg border bg-background p-4 transition-colors hover:bg-accent"
              >
                <div className="flex items-start gap-3">
                  <Icon className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
                  <div>
                    <div className="text-sm font-medium">{link.label}</div>
                    <div className="text-sm text-muted-foreground">{link.description}</div>
                  </div>
                </div>
                <ExternalLink className="h-4 w-4 shrink-0 text-muted-foreground" />
              </a>
            );
          })}
        </div>
      </section>

      <section className="space-y-2">
        <div className="text-sm font-semibold">Support</div>
        <a
          href="/contact"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between gap-4 rounded-lg border bg-background p-4 transition-colors hover:bg-accent"
        >
          <div className="flex items-start gap-3">
            <LifeBuoy className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
            <div>
              <div className="text-sm font-medium">Contact Support</div>
              <div className="text-sm text-muted-foreground">Get help or report a problem.</div>
            </div>
          </div>
          <ExternalLink className="h-4 w-4 shrink-0 text-muted-foreground" />
        </a>
      </section>

      <section className="space-y-2">
        <div className="text-sm font-semibold">App</div>
        <div className="flex items-center justify-between rounded-lg border bg-background p-4 text-sm">
          <span className="text-muted-foreground">Version</span>
          <span className="font-mono">{APP_VERSION}</span>
        </div>
      </section>
    </div>
  );
};
